function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip, { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { MFATooltipContent } from './MFATooltipContent';
export const MFAIcon = _ref => {
  let {
    containerRef
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, {
    triggerTarget: OverflowTooltip.TRIGGER_TARGETS.TOOLTIP,
    content: /*#__PURE__*/React.createElement(MFATooltipContent, null),
    renderTarget: props => /*#__PURE__*/React.createElement(Tooltip.Target, _extends({}, props, {
      shouldWrapChildren: false
    })),
    container: containerRef
  }, /*#__PURE__*/React.createElement(AlertWarningIcon, {
    "data-testid": "MFAIcon",
    style: {
      margin: "auto ".concat(theme.spacing.xSmall, "px"),
      color: theme.colors.yellowOrange500
    }
  }));
};
//# sourceMappingURL=MFAIcon.js.map